import axios from 'axios';
import { settings } from '../config';

export async function fetchPayments() {
  const config = {
    headers: {
      Authorization: 'Bearer 4478c2b6-525f-4b48-99a2-1e9e7da835b7',
    },
  };
  try {
    const url = `${settings.url}/donation/?currency_type=hearts`;
    const response = await axios.get(url, config);
    return response.data;
  } catch (e) {
    console.log('ОШИБКА', e);
  }
}

export async function buyPayment(
  item_type: string,
  item_quantity: number,
  description: string,
) {
  const config = {
    headers: {
      Authorization: 'Bearer 4478c2b6-525f-4b48-99a2-1e9e7da835b7',
    },
  };
  try {
    const url = `${settings.url}/donation/donate`;
    const response = await axios.post(
      url,
      {
        item_type,
        item_quantity,
        description,
      },
      config,
    );
    return response.data;
  } catch (e) {
    console.log('ОШИБКА', e);
  }
}
